exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-dropdown.cap-dropdown-v2-overlay{min-width:200px}.ant-dropdown.cap-dropdown-v2-overlay .ant-dropdown-menu.cap-menu-v2 .ant-dropdown-menu-item{padding:12px 24px}.ant-dropdown.cap-dropdown-v2-overlay .ant-dropdown-menu.cap-menu-v2 .ant-dropdown-menu-item:hover,.ant-dropdown.cap-dropdown-v2-overlay .ant-dropdown-menu.cap-menu-v2 .ant-dropdown-menu-submenu-title:hover{background-color:#faf9f4}\n", ""]);

// exports
